// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__XefKq","title":"Images45_title__NqxMc","images":"Images45_images__3V-iI"};